import React from "react";
import { BulletIcon } from "../../../assets";

const missionItems = [
	{
		title: "Akses merata",
		description: "persiapan IELTS efektif untuk siapapun di Indonesia, tanpa hambatan geografis maupun waktu",
	},
	{
		title: "Garansi hasil",
		description: "komitmen konkret yang bisa dipegang siswa, bukan sekedar janji marketing",
	},
	{
		title: "Mentor terbukti",
		description: "tutor alumni luar negeri yang sudah melewati proses IELTS dan beasiswa secara nyata",
	},
	{
		title: "Personalized",
		description: "kurikulum berdasarkan skill diagnostic, bukan template general yang sama untuk semua orang",
	},
];

const cardIcon = <img src={BulletIcon} alt="" className="h-5 w-5 sm:h-6 sm:w-6" loading="lazy" />;

const WhyScholarsTodayExist = () => {
	return (
		<section className="st-aboutus-why overflow-hidden px-4 py-14 sm:py-16 lg:py-20">
			<div className="mx-auto w-full max-w-7xl">
				<div className="mx-auto max-w-[980px] text-center">
					<h2 className="st-aboutus-why-title st-font-display text-[40px] leading-[0.96] tracking-[-0.03em] sm:text-[52px] md:text-[60px] lg:text-[66px]">
						Why Does
						<br />
						<span className="st-aboutus-why-title-emphasis italic">ScholarsToday</span> Exist?
					</h2>

					<p className="st-aboutus-why-intro st-font-body text-zinc-800 mx-auto mt-6 max-w-[900px] text-[14px] leading-[1.75] sm:text-[16px] md:text-[17px] lg:text-[24px]">
						Melalui visi dan misi berikut, ScholarsToday ingin membantu lebih banyak pelajar Indonesia
						raih peluang pendidikan dan karier global melalui pembelajaran IELTS yang lebih terarah!
					</p>
				</div>

				<div className="mx-auto mt-10 max-w-[1120px] sm:mt-12">
					<article className="relative rounded-[24px] border-[2px] border-[#c62c16] bg-white px-5 pb-7 pt-8 shadow-[0_12px_24px_rgba(34,24,19,0.1)] sm:px-8 sm:pb-8 sm:pt-9 lg:px-10 lg:pb-10 lg:pt-10">
						<div className="flex items-center gap-4">
							<div className="h-px flex-1 bg-[#d8d1c7]" />
							<span className="rounded-full bg-[#c62c16] px-5 py-2 text-[11px] font-bold uppercase tracking-[0.18em] text-white sm:px-6 sm:text-[16px]">
								Vision
							</span>
						</div>

						<p className="mt-6 max-w-[920px] text-left font-[Inter] text-[14px] leading-[1.75] text-[#4a4239] sm:text-[15px] lg:text-[16px]">
							Menjadi <span className="font-bold">jembatan</span> paling <span className="font-bold">terpercaya</span> bagi <span className="font-bold">generasi Indonesia</span> yang bermimpi <span className="font-bold">belajar di luar negeri</span> dengan memastikan <span className="font-bold">tidak ada yang gagal</span> hanya karena <span className="font-bold">hambatan skor</span> IELTS.
						</p>

						<div className="mt-8 flex items-center gap-4 sm:mt-9">
							<span className="rounded-full bg-[#c62c16] px-5 py-2 text-[11px] font-bold uppercase tracking-[0.18em] text-white sm:px-6 sm:text-[16px]">
								Mission
							</span>
							<div className="h-px flex-1 bg-[#d8d1c7]" />
						</div>

						<div className="mt-8 grid gap-x-8 gap-y-6 sm:grid-cols-2 sm:gap-y-7 lg:mt-9 lg:gap-x-10 lg:gap-y-8">
							{missionItems.map((item) => (
								<div key={item.title} className="flex items-start gap-3 sm:gap-4">
									<span className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center sm:h-7 sm:w-7">
										{cardIcon}
									</span>

									<p className="font-[Inter] text-[13px] leading-[1.55] text-[#4a4239] sm:text-[14px] lg:text-[16px]">
										<span className="font-bold text-[#2b2420]">{item.title}</span> — {item.description}
									</p>
								</div>
							))}
						</div>
					</article>
				</div>
			</div>
		</section>
	);
};

export default WhyScholarsTodayExist;
